import React from "react";
import { Link } from "react-router-dom";
import "./PartnerStrip.css";

// Populate this array as agencies are onboarded. Empty array = renders nothing.
const PARTNERS = [
    { id: 1, name: "AA Devine", logo: "/images/AADevine.png", path: "/partners/aa-devine" },
    { id: 2, name: "Test Partner 2", logo: "/images/logoPlaceholder1.png", path: "/apply" },
    { id: 3, name: "Test Partner 3", logo: "/images/logoPlaceholder1.png", path: "/apply" },
    { id: 4, name: "Test Partner 4", logo: "/images/logoPlaceholder1.png", path: "/apply" },
    { id: 5, name: "Test Partner 5", logo: "/images/logoPlaceholder1.png", path: "/apply" },
    { id: 6, name: "Test Partner 6", logo: "/images/logoPlaceholder1.png", path: "/apply" },
    { id: 7, name: "Test Partner 7", logo: "/images/logoPlaceholder1.png", path: "/apply" },
    { id: 8, name: "Test Partner 8", logo: "/images/logoPlaceholder1.png", path: "/apply" },
];

const PartnerStrip = ({ partners = PARTNERS }) => {
    if (!partners || partners.length === 0) {
        return null;
    }

    return (
        <div className="partner-strip-wrapper">
            <div className="partner-strip-track">
                {partners.map((partner) => (
                    <Link
                        to={partner.path}
                        key={partner.id}
                        className="partner-badge"
                    >
                        <img src={partner.logo} alt={partner.name} />
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default PartnerStrip;